import { isEmpty } from 'lodash';

import { Box, Chip, Typography } from '@mui/material';

import { formatLocationDetails } from 'src/utils';

import { FlagIcon } from 'src/components/flag-icon';

type MainLayoutLeftAreaProps = {
  title: string;
  country: string;
  city: string;
  jobMode: string;
  countryDetails: { label: string; id: string };
};

export function MainLayoutLeftArea({
  title,
  country,
  city,
  jobMode,
  countryDetails,
}: MainLayoutLeftAreaProps) {
  return (
    <Box component="div" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box component="div" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h5">{title}</Typography>
        <Box component="div" sx={{ display: 'flex', gap: 1 }}>
          {!isEmpty(countryDetails.id) && (
            <FlagIcon key={countryDetails.label} code={countryDetails.id} />
          )}
          <Typography variant="subtitle2">
            {formatLocationDetails({
              LocationCountry: country,
              LocationCity: city,
              LocationState: '',
              LocationZipCode: '',
            })}
          </Typography>
          {!isEmpty(jobMode) && <Chip label={jobMode} size="small" variant="soft" color="default" />}
        </Box>
      </Box>
    </Box>
  );
}
